import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import login from './login'

export default {
  login,
  ...zhLocale,
}
